import React from "react";
import { ComponentEventHandler, MenuProps, Menu } from "@fluentui/react-northstar";
import { Tab } from "shared/models/Tab";
import styles from "./tabs.module.scss";
import classNames from "classnames";

interface TabsProps {
    activeTab: number;
    activeIndex?: number;
    items: Tab[];
    additionalClassName?: string;
    vertical?: boolean;

    onActiveIndexChange: ComponentEventHandler<MenuProps>;
}

const Tabs: React.FC<TabsProps> = (props: TabsProps) => {
    return (
        <div style={{ marginBottom: "2px" }} className={classNames(styles.menuWrapper, props.additionalClassName)}>
            {/* Inline style is attempt to override tabs defaults styles required due to CSS hierarchy */}
            <Menu
                style={{ borderBottomColor: "transparent", textAlign: props.vertical ? "left" : "center" }}
                defaultActiveIndex={props.activeTab}
                activeIndex={props.activeIndex}
                items={props.items}
                underlined
                primary
                vertical={props.vertical}
                onActiveIndexChange={props.onActiveIndexChange}
            />
        </div>
    );
};

export default Tabs;
